import './notification.scss';

export default () => {
	const notification = document.querySelector( '.js-notification' );
	const closeBtn = document.querySelector( '.js-notification' );

	if ( notification ) {
		if ( getCookie( 'notificationClosed' ) ) {
			notification.style.display = 'none';
		}

		closeBtn.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			notification.style.display = 'none';
			setCookie( 'notificationClosed', 'true', 1 );
		} );
	}

	function getCookie ( name ) {
		const cookies = document.cookie.split( '; ' );

		for ( let i = 0;i < cookies.length;i++ ) {
			const cookie = cookies[ i ].split( '=' );

			if ( cookie[ 0 ] === name ) {
				return cookie[ 1 ];
			}
		}

		return null;
	}

	function setCookie ( name, value, days ) {
		const date = new Date();

		date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
		const expires = `expires=${date.toUTCString()}`;

		document.cookie = `${name}=${value}; ${expires}; path=/`;
	}
};
